import { CommunicationDto, UpdateCommunicationRequest } from '@/api/ApiClient';

/** Maps tree/detail state to the PUT communications body (editable fields only). */
export function toUpdateCommunicationRequest(dto: CommunicationDto): UpdateCommunicationRequest {
  return {
    id: dto.id!,
    title: dto.title,
    format: dto.format,
    participants: dto.participants,
    text: dto.text,
    date: dto.date,
  };
}
